module.exports = __webpack_public_path__ + "img/eyes.23d16a55.svg";